// extracted by mini-css-extract-plugin
export default {"modal":"K8wZrhwhYLKMCkkyc63T","content":"xdZ4LbKQ7lnqNYA8v5Bw"};